export default __webpack_public_path__ + "static/media/globe.82db4a3c.png";